var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      show: _vm.visible,
      title: _vm.isEditing
        ? _vm.$t("Editar Exceção Fiscal")
        : _vm.$t("Adicionar Exceção Fiscal"),
      fetching: _vm.fetching,
      width: "900px",
    },
    on: {
      save: _vm.save,
      hidden: function ($event) {
        _vm.visible = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "FormulateForm",
              { ref: "itemForm", on: { submit: _vm.save } },
              [
                _c(
                  "b-alert",
                  {
                    staticClass: "p-1 mb-2",
                    attrs: { show: "", variant: "warning" },
                  },
                  [
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "Esta configuração define uma classificação fiscal que substitui a classificação do NCM para todos os produtos associados a este cadastro."
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("br"),
                      _c("li", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                'Se houver NCM informado em "Informações Gerais", ao selecionar uma "UF de origem" os valores do NCM serão carregados para que você altere somente os parâmetros que deseja configurar como exceção.'
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "b-tabs",
                  { attrs: { fill: "" } },
                  [
                    _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("Identificação") } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "mt-1" },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-state",
                                    name: "state",
                                    type: "vue-select",
                                    label: _vm.$t("UF de Origem"),
                                    placeholder: _vm.$t("Todas as UFs"),
                                    options: _vm.comboStates,
                                    instruction: _vm.$t(
                                      "Deixe em branco para valer como regra geral do cadastro, em qualquer estado"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.state,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "state", $$v)
                                    },
                                    expression: "form.state",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-operation-type",
                                    name: "operationType",
                                    type: "vue-select",
                                    label: _vm.$t("Tipo de Operação"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboOperationTypes,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.operationType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "operationType", $$v)
                                    },
                                    expression: "form.operationType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.isInterstate
                              ? _c(
                                  "b-col",
                                  { attrs: { md: "4" } },
                                  [
                                    _c("FormulateInput", {
                                      staticClass: "required",
                                      attrs: {
                                        id: "tax-configuration-group-item-destination-state",
                                        name: "destinationState",
                                        type: "vue-select",
                                        label: _vm.$t("UF de Destino"),
                                        placeholder: _vm.$t("Selecione"),
                                        options: _vm.comboStates,
                                        validation: "required",
                                      },
                                      model: {
                                        value: _vm.form.destinationState,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "destinationState",
                                            $$v
                                          )
                                        },
                                        expression: "form.destinationState",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-cfop-output",
                                    name: "cfopOutput",
                                    type: "vue-select",
                                    label: _vm.$t("Cfop Saída"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCfopOutput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.cfopOutput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "cfopOutput", $$v)
                                    },
                                    expression: "form.cfopOutput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-cfop-input",
                                    name: "cfopInput",
                                    type: "vue-select",
                                    label: _vm.$t("Cfop Entrada"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCfopInput,
                                  },
                                  model: {
                                    value: _vm.form.cfopInput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "cfopInput", $$v)
                                    },
                                    expression: "form.cfopInput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-benefit-code",
                                    name: "benefitCode",
                                    type: "text",
                                    label: _vm.$t("Código de Benefício Fiscal"),
                                  },
                                  model: {
                                    value: _vm.form.benefitCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "benefitCode", $$v)
                                    },
                                    expression: "form.benefitCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("ICMS") } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "mt-1" },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-icms",
                                    name: "stIcms",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Icms"),
                                    placeholder: _vm.$t("Selecione"),
                                    validation: "required",
                                    options: _vm.comboCstIcms,
                                  },
                                  model: {
                                    value: _vm.form.stIcms,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stIcms", $$v)
                                    },
                                    expression: "form.stIcms",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-csosn-icms",
                                    name: "csosnIcms",
                                    type: "vue-select",
                                    label: _vm.$t("Csosn Icms"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.comboCsosnIcms,
                                  },
                                  model: {
                                    value: _vm.form.csosnIcms,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "csosnIcms", $$v)
                                    },
                                    expression: "form.csosnIcms",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-icms-percent",
                                    name: "icmsPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Alíquota Icms"),
                                  },
                                  model: {
                                    value: _vm.form.icmsPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "icmsPercent", $$v)
                                    },
                                    expression: "form.icmsPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-icms-base-reduction-percent",
                                    name: "icmsBaseReductionPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Redução Base Icms"),
                                  },
                                  model: {
                                    value: _vm.form.icmsBaseReductionPercent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "icmsBaseReductionPercent",
                                        $$v
                                      )
                                    },
                                    expression: "form.icmsBaseReductionPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-fcp-percent",
                                    name: "fcpPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t(
                                      "Alíquota Fundo de Combate à Pobreza"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.fcpPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fcpPercent", $$v)
                                    },
                                    expression: "form.fcpPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-iva",
                                    name: "iva",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Iva"),
                                  },
                                  model: {
                                    value: _vm.form.iva,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "iva", $$v)
                                    },
                                    expression: "form.iva",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-icms-st-percent",
                                    name: "icmsStPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Alíquota Icms St"),
                                  },
                                  model: {
                                    value: _vm.form.icmsStPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "icmsStPercent", $$v)
                                    },
                                    expression: "form.icmsStPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-icms-st-base-reduction-percent",
                                    name: "icmsStBaseReductionPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Redução Base Icms St"),
                                  },
                                  model: {
                                    value: _vm.form.icmsStBaseReductionPercent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "icmsStBaseReductionPercent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.icmsStBaseReductionPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-fcp-st-percent",
                                    name: "fcpStPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Alíquota Fcp St"),
                                  },
                                  model: {
                                    value: _vm.form.fcpStPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fcpStPercent", $$v)
                                    },
                                    expression: "form.fcpStPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-icms-tax-relief-reason",
                                    name: "icmsTaxReliefReason",
                                    type: "vue-select",
                                    label: _vm.$t(
                                      "Motivo da Desoneração do Icms"
                                    ),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.comboIcmsTaxReliefReason,
                                  },
                                  model: {
                                    value: _vm.form.icmsTaxReliefReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "icmsTaxReliefReason",
                                        $$v
                                      )
                                    },
                                    expression: "form.icmsTaxReliefReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("PIS/COFINS e IPI") } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "mt-1" },
                          [_c("b-col", [_c("h5", [_vm._v("PIS")])])],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-pis-output",
                                    name: "stPisOutput",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Pis Saída"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCstPisCofinsOutput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.stPisOutput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stPisOutput", $$v)
                                    },
                                    expression: "form.stPisOutput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-pis-input",
                                    name: "stPisInput",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Pis Entrada"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCstPisCofinsInput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.stPisInput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stPisInput", $$v)
                                    },
                                    expression: "form.stPisInput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-pis-percent",
                                    name: "pisPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Alíquota Pis"),
                                  },
                                  model: {
                                    value: _vm.form.pisPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "pisPercent", $$v)
                                    },
                                    expression: "form.pisPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          { staticClass: "mt-1" },
                          [_c("b-col", [_c("h5", [_vm._v("COFINS")])])],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-cofins-output",
                                    name: "stCofinsOutput",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Cofins Saída"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCstPisCofinsOutput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.stCofinsOutput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stCofinsOutput", $$v)
                                    },
                                    expression: "form.stCofinsOutput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-cofins-input",
                                    name: "stCofinsInput",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Cofins Entrada"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCstPisCofinsInput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.stCofinsInput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stCofinsInput", $$v)
                                    },
                                    expression: "form.stCofinsInput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-cofins-percent",
                                    name: "cofinsPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Alíquota Cofins"),
                                  },
                                  model: {
                                    value: _vm.form.cofinsPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "cofinsPercent", $$v)
                                    },
                                    expression: "form.cofinsPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          { staticClass: "mt-1" },
                          [_c("b-col", [_c("h5", [_vm._v("IPI")])])],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-ipi-output",
                                    name: "stIpiOutput",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Ipi Saída"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCstIpiOutput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.stIpiOutput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stIpiOutput", $$v)
                                    },
                                    expression: "form.stIpiOutput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "required",
                                  attrs: {
                                    id: "tax-configuration-group-item-st-ipi-input",
                                    name: "stIpiInput",
                                    type: "vue-select",
                                    label: _vm.$t("Cst Ipi Entrada"),
                                    placeholder: _vm.$t("Selecione"),
                                    options: _vm.getComboCstIpiInput,
                                    validation: "required",
                                  },
                                  model: {
                                    value: _vm.form.stIpiInput,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stIpiInput", $$v)
                                    },
                                    expression: "form.stIpiInput",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-ipi-percent",
                                    name: "ipiPercent",
                                    type: "text-percetage",
                                    currency: "%",
                                    precision: 4,
                                    label: _vm.$t("Alíquota Ipi"),
                                  },
                                  model: {
                                    value: _vm.form.ipiPercent,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "ipiPercent", $$v)
                                    },
                                    expression: "form.ipiPercent",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "tax-configuration-group-item-ipi-legal-framework-code",
                                    name: "ipiLegalFrameworkCode",
                                    type: "text",
                                    label: _vm.$t(
                                      "Código de Enquadramento Legal"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.ipiLegalFrameworkCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "ipiLegalFrameworkCode",
                                        $$v
                                      )
                                    },
                                    expression: "form.ipiLegalFrameworkCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }